import { create } from 'zustand'
import { persist } from 'zustand/middleware'

import type { ThemePreference, UiState } from './ui.store.types'

/** Client-only UI preferences (docs/03 §4: Zustand for UI state). */
export const useUiStore = create<UiState>()(
  persist(
    (set) => ({
      theme: 'light',
      design: 'gxlabs',
      navOpen: false,
      sidebarWidth: null,
      navCollapsed: false,
      navClosedGroups: [],
      mediaView: 'grid',
      uiLocale: 'en',
      notificationSound: true,
      setNotificationSound: (notificationSound) => set({ notificationSound }),
      setUiLocale: (uiLocale) => set({ uiLocale }),
      setTheme: (theme) => set({ theme }),
      setDesign: (design) => set({ design }),
      setNavOpen: (navOpen) => set({ navOpen }),
      setSidebarWidth: (sidebarWidth) => set({ sidebarWidth }),
      setNavCollapsed: (navCollapsed) => set({ navCollapsed }),
      setNavGroupsOpen: (ids, open) =>
        set((s) => ({
          navClosedGroups: open
            ? s.navClosedGroups.filter((g) => !ids.includes(g))
            : [...new Set([...s.navClosedGroups, ...ids])],
        })),
      setMediaView: (mediaView) => set({ mediaView }),
    }),
    {
      name: 'gx-cms-ui',
      partialize: (s) => ({
        theme: s.theme,
        design: s.design,
        mediaView: s.mediaView,
        uiLocale: s.uiLocale,
        notificationSound: s.notificationSound,
        sidebarWidth: s.sidebarWidth,
        navCollapsed: s.navCollapsed,
        navClosedGroups: s.navClosedGroups,
      }),
    },
  ),
)

export function resolveTheme(pref: ThemePreference): 'light' | 'dark' {
  if (pref !== 'system') return pref

  return window.matchMedia?.('(prefers-color-scheme: dark)').matches
    ? 'dark'
    : 'light'
}
